import { connect } from "react-redux";
import { withRouter } from "react-router";
import { push } from "react-router-redux";
import TopAppBar from "../components/TopAppBar";

export default withRouter(
  connect(
    (state, props) => ({}),
    (dispatch, props) => ({
      initialActions() {},
      goToPath(path) {
        dispatch(push(path));
      }
    })
  )(TopAppBar)
);
